var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddBusiness = function SvgAddBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "add_business_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#add_business_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 20h-2a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 19q0-.424.287-.712A.97.97 0 0 1 16 18h2v-2q0-.424.288-.713A.97.97 0 0 1 19 15q.424 0 .712.287.288.288.288.713v2h2q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 22 20h-2v2q0 .424-.288.712A.97.97 0 0 1 19 23a.97.97 0 0 1-.712-.288A.97.97 0 0 1 18 22zM3 20a.97.97 0 0 1-.712-.288A.97.97 0 0 1 2 19v-5h-.175a.96.96 0 0 1-.775-.363.95.95 0 0 1-.2-.837l1-5a1 1 0 0 1 .35-.575A.96.96 0 0 1 2.825 7h13.35a.96.96 0 0 1 .625.225q.275.225.35.575l1 5a.95.95 0 0 1-.2.837.96.96 0 0 1-.775.363H17v2q0 .424-.288.712A.97.97 0 0 1 16 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 16v-2h-4v5q0 .424-.287.712A.97.97 0 0 1 10 20zm1-2h5v-4H4zM3 6a.97.97 0 0 1-.712-.287A.97.97 0 0 1 2 5q0-.424.288-.713A.97.97 0 0 1 3 4h13q.424 0 .712.287Q17 4.576 17 5q0 .424-.288.713A.97.97 0 0 1 16 6zm.05 6h12.9l-.6-3H3.65z"
  }))));
};
export default SvgAddBusiness;